import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PiSealCheck,
  PiSealPercent,
  PiSealQuestion,
  PiSealWarning,
  PiX,
} from 'react-icons/pi';
import { CONTRACT_STATUS } from 'services/contract/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledContractStatusProps {
  status: CONTRACT_STATUS;
}

interface ILabeledContractStatusParams extends IColorProp {
  status: CONTRACT_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledContractStatusParams[] = [
  {
    status: CONTRACT_STATUS.unknown,
    color: 'gray',
    icon: <PiSealQuestion />,
  },
  {
    status: CONTRACT_STATUS.offer,
    color: 'orange',
    icon: <PiSealPercent />,
  },
  {
    status: CONTRACT_STATUS.active,
    color: 'blue',
    icon: <PiSealCheck />,
  },
  {
    status: CONTRACT_STATUS.withdraw,
    color: 'gray',
    icon: <PiSealWarning />,
  },
  {
    status: CONTRACT_STATUS.rejected,
    color: 'red',
    icon: <PiX />,
  },
];

const LabeledContractStatus = ({ status }: ILabeledContractStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];

  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(
        `enum.CONTRACT_STATUS.${CONTRACT_STATUS[labeledParams.status]}`
      )}>
      {labeledParams.icon}{' '}
      {t(`enum.CONTRACT_STATUS.${CONTRACT_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledContractStatus;
